import { atomWithStorage } from '@capsicum/common';

export const onboardingDoneAtom = atomWithStorage<boolean>('onboardingDone', false);
